// extracted by mini-css-extract-plugin
module.exports = {"back__container":"style_back__container__g_9zx","back__separator":"style_back__separator__ndWpI"};